var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/delete.3bee73d4.png","uri@3x": __webpack_public_path__ + "static/media/delete.6ac4621a.png","uri@2x": __webpack_public_path__ + "static/media/delete.9bf4850b.png",
    width: 19,
    height: 24
});